<template>
    <div class='content boxShadow flex' v-if="datas" @click.stop="gotoDetail(datas.id)">
        <!-- 猎头岗位角标 -->
        <div class="headhunter-ribbon" v-if="datas.headhunterPosition">猎头岗位</div>
        <div class="content-box content-left" @click.stop="gotoDetail(types==1? datas.id : datas.positionId)">
            <div style="height: 56px;">
                <div class="flex" style="padding-bottom: 10px;" >
                    <!-- <p class="content-box-name textOver">{{datas.name}} {{ datas.address? '【' +datas.address +'】' :'' }}</p> -->
                    <p class="content-box-name textOver">{{types==1?datas.name:datas.positionName}}</p>
                    <img v-if="datas.recommended" src="../../../assets/images/newicon/hot.png" alt="" />
                    <p class="shrink content-left-salary">{{datas.salaryRangeName}}</p>
                </div>
                <Btns v-if="datas.workExperienceName" :value="datas.workExperienceName"></Btns>
                <Btns v-if="datas.qualificationsName" :value="datas.qualificationsName"></Btns>
                <Btns v-if="datas.positionTypeName" :value="datas.positionTypeName"></Btns>
                <Btns v-if="datas.jobRecruiters" :types="2" :value="datas.jobRecruiters"></Btns>
            </div>
            <div class="flex content-box-illustrate textOver">
                <!-- <p class="textOver">{{datas.address}}</p> -->
                <p v-for="item in  datas.welfareInfos">
                   {{ item.welfareName }}
                </p>
            </div>
        </div>
        <div class="content-box content-otherinfo">
            <div class="flex ">
                <img :src="datas.avatarUrl" alt=""  class="shrink"/>
                <div class="shrink" style="width: 80%;height: 56px;">
                    <div class="flex itemsCenter" style="padding-bottom: 10px;">
                        <p class="content-box-name textOver" @click.stop="gotoCompany(datas.companyId)">{{datas.companyName}}</p>
                        
                        <!-- 职位详情 -->
                        <div v-if="types==1" class="shrink flex content-box-collect itemsCenter" 
                            :class="datas.favorite?'content-box-collected':''" 
                            @click.stop="collectJob(datas.id,datas.favorite)"> 
                            <span v-if="datas.favorite" class="fonticon">&#xe623;</span>
                            <span v-else class="fonticon">&#xe62f;</span>
                            {{datas.favorite?"取消收藏":"未收藏"}}
                        </div>
                        <!-- 收藏列表 -->
                        <div v-if="types==3" class="shrink flex content-box-collect itemsCenter content-box-collected" 
                            @click.stop="collectJob(datas.positionId,true)"> 
                            <span class="fonticon">&#xe623;</span>
                            <!-- <span v-else class="fonticon">&#xe62f;</span> -->
                            取消收藏
                        </div>
                    </div>
                    <div class="flex">
                        <Btns  :isWidth="true" class="shrink" :value="datas.industryTypeName"></Btns>
                        <Btns  :isWidth="true" class="shrink" :value="datas.financeTypeName"></Btns>
                        <Btns  :isWidth="true" class="shrink" :value="datas.scaleName"></Btns>
                        
                    </div>
                    
                </div>
               
            </div>
            
            <div class="flex content-box-illustrate">
                <p class="textOver">{{datas.address}}</p>
                <!-- <p class="textOver">品牌推广阶段看风景的开始了快递发货速度发三闾大夫都死了家里的金富来大厦里的领导说了</p> -->
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import {mapGetters} from 'vuex'
  import Btns from '../../../components/Btn.vue';
  export default {
    props: {
        datas:{
            type:Object,
            default:null
        },
        types:{
            type:Number,
            default:1
        }
    },
    data() {
        return {
            collect:false,
        };
    },
    components: {
        Btns
    },
    methods: {
        handleChange(key,value){
        }, 
        //职位的收藏与取消
        collectJob(id,collect){
            if(this.isLogin){
                this.$emit('updateFavorite',id,collect)
            }else{
               return this.$message.warning("请先登陆！");
            }
            
            
        },
        gotoDetail(id){
            window.open(`/job/detail?id=${id}`);
        },
        gotoCompany(id){
            window.open(`/company/detail?id=${id}`);
        },
        
        
    
    },
    computed:{
        ...mapGetters([
         "isLogin"
      ]),
    }


  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  .content{
    width: 954px;
    margin-bottom: 20px;
    background: @whiteColor;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .2s linear;
    position: relative;
    overflow: hidden;
    .headhunter-ribbon{
        position: absolute;
        top: 6px;
        left: -36px;
        width: 120px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        transform: rotate(-45deg);
        background: @mianColor;
        color: @whiteColor;
        font-size: 12px;
        z-index: 2;
        pointer-events: none;
    }
    &:hover{
        box-shadow: 0 16px 40px 0 hsla(0,0%,60%,.3);
        z-index: 3;
    }
    &-box{
        padding: 24px 24px 14px;
        &-name{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            color: @mainFontCol;
            cursor: pointer;
        }
        &-illustrate{
            padding-top: 14px;
            margin-top: 20px;
            border-top: 1px dotted #D9D9D9;
            overflow: hidden;
            p{
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: @secondfontCol;
                padding-right: 24px;
            }
            
        }
        &-collect{
            height: 24px;
            border-radius: 12px;
            padding: 0 10px;
            border: 1px solid #287CF3;
            margin-left: 10px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color:  @mianColor;
            cursor: pointer;
            .fonticon{
                padding-right: 4px;
            }


        }
        &-collected{
            background: rgba(40,124,243,0.2);
        }
    }
    &-left{
        width: 548px;
        flex-shrink: 0;
        box-sizing: border-box;
        img{
            width: 60px;
            height: 24px;
            margin: 0 12px;
        }
        &-salary{
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FF8A16;
            padding-left: 10px;
        }

    }
    &-otherinfo{
        width: 406px;
        flex-shrink: 0;
        box-sizing: border-box;
        background: linear-gradient(270deg, #FFFFFF 0%, #F9FBFC 100%);
        border-radius: 0px 6px 6px 0px;
        img{
            width: 56px;
            height: 56px;
            background: #D8D8D8;
            border-radius: 6px;
            margin-right: 10px;
        }
    }
  }
 
  </style>
  